export const defaultTheme = {
  backgroundColor: "#ffe8c2",
  headerBackground: "#e0c194",
  constactUsHeaderLeft: "#fefefe99",
  constactUsHeaderRight: "#ffffffc8",
  contactUsHedaerColor: "#012f5b",
  portfolioPageHeaderBackground: "#012f5b",
  backdrop: "#0000004e",
  cardBackground: "#fff",
  fontColorBlack: "#000000",
  fontColorWhite: "#ffffff",
  testimonialsCardBackgroud: "#ffffff",
  borderColor: "#e0c194",
  sectionHeaderColor: "#f35e1e",
  servicesBackground: "#fff"
};

export const blackTheme = {
  backgroundColor: "#1B3C53",
  headerBackground: "#012f5b",
  constactUsHeaderLeft: "#000000aa",
  constactUsHeaderRight: "#000000c7",
  contactUsHedaerColor: "#ffffff",
  portfolioPageHeaderBackground: "#6a6a6a",
  backdrop: "#ffffff2b",
  cardBackground: "#7db4dd",
  fontColorBlack: "#ffffff",
  fontColorWhite: "#000000",
  testimonialsCardBackgroud: "#234C6A",
  borderColor: "#ffffff",
  sectionHeaderColor: "#ffffff",
  servicesBackground: "#dddcdc",
};
